const ar = {
  loading: "جارٍ التحميل…",
  nav_home: "الرئيسية", nav_liberty: "ليبرتي", nav_partner: "الشركاء", nav_contatti: "اتصل بنا",
  nav_accedi: "تسجيل الدخول", nav_richiedi: "اطلب الوصول", nav_area: "المنطقة الشخصية", nav_admin: "الإدارة",
  foot_tagline: "رأس مال خاص. ذكاء مُهيكل.",
  foot_col_site: "ليبرتي", foot_col_accesso: "الوصول", foot_col_legali: "الشؤون القانونية",
  foot_legal_soc: "معلومات الشركة", foot_legal_rischi: "بيان المخاطر", foot_legal_privacy: "الخصوصية", foot_legal_termini: "الشروط",
  foot_rights: "Liberty Capital & Partners",
  disclaimer: "تنطوي الاستثمارات على مخاطر خسارة رأس المال. النتائج السابقة ليست مؤشراً على النتائج المستقبلية. تخضع المشاركة للتحقق وللوثائق التعاقدية.",
  cookie_title: "ملفات تعريف الارتباط",
  cookie_text: "نستخدم فقط ملفات تعريف الارتباط التقنية اللازمة لعمل الموقع وأمان المنطقة المخصصة. يمكنك القبول أو الرفض.",
  cookie_accept: "قبول", cookie_reject: "رفض",

  hero_eyebrow: "Liberty Capital & Partners",
  hero_tagline: "مكتب خاص دولي، مبني حول رأس المال.",
  hero_sub: "هيكل خاص لتنظيم رأس المال وتخصيصه، تقوده استراتيجية محايدة للسوق مبنية على أربعة مستويات مستقلة.",
  hero_cta1: "اكتشف المشروع", hero_cta2: "اطلب الوصول",
  hero_micro: "Private capital. Structured intelligence.",
  marq_1: "التحفظ", marq_2: "الدقة", marq_3: "السيطرة", marq_4: "الذكاء", marq_5: "Private capital", marq_6: "Market neutral",

  lib_eyebrow: "01 — ليبرتي", lib_title_pre: "", lib_title_em: "الهيكل",
  lib_p1: "ليبرتي كابيتال آند بارتنرز هي هيكل خاص مخصص لتنظيم رأس المال وتخصيصه من خلال بنية متعددة المستويات.",
  lib_p2: "ليست صندوقاً. وليست بنكاً.",
  lib_p3: "الوصول انتقائي، وتخضع العلاقات مع المشاركين لاتفاقيات فردية وللوثائق التعاقدية ذات الصلة.",
  lvl1_name: "Spot + Staking", lvl1_alloc: "~60%",
  lvl1_text: "شراء واحتفاظ بالأصول الرقمية مع دورة ستيكينغ مستمرة.",
  lvl2_name: "Lending & Borrowing", lvl2_alloc: "30–40%",
  lvl2_text: "عملات مستقرة مُقرضة على بروتوكولات DeFi/CeFi منظمة.",
  lvl3_name: "Funding Arbitrage", lvl3_alloc: "~5%",
  lvl3_text: "دلتا محايدة: مركزان طويل وقصير على الأداة نفسها عبر منصتين.",
  lvl4_name: "Active Trading", lvl4_alloc: "10–15%",
  lvl4_text: "عمليات نشطة مع وقف خسارة صارم: حد أقصى للخسارة 1% من المحفظة لكل عملية.",
  lib_cta: "اكتشف ليبرتي",

  prog_eyebrow: "02 — البرنامج", prog_title_pre: "استراتيجية", prog_title_em: "محايدة للسوق", prog_title_post: ".",
  prog_p1: "برنامج Safe Capital هو استراتيجية ليبرتي: نهج محايد للسوق، حيث لا يعتمد الأداء على اتجاه الأسواق.",
  prog_p2: "يُخصَّص رأس المال عبر أربعة مستويات استراتيجية مستقلة وغير مترابطة، مقوَّم بعملات مستقرة (USDT/USDC) للحد من التعرض للتقلبات.",
  prog_cta: "اكتشف البرنامج",
  prog_card_label: "هدف البرنامج", prog_card_sub: "صافي شهري",
  prog_card_note: "نتائج موثقة على 11 شهراً: متوسط 1.24% صافي شهري. النتائج السابقة ليست مؤشراً على النتائج المستقبلية.",

  how_eyebrow: "03 — كيف يعمل", how_title_pre: "من العقد إلى", how_title_em: "التشغيل",
  how_sub: "عملية محددة كتابياً، خطوة بخطوة.",
  step1_t: "وقّع العقد", step1_x: "تبدأ العلاقة مع ليبرتي كابيتال آند بارتنرز بوثائق تعاقدية تحدد الأدوار والتدفقات والشروط.",
  step2_t: "حوّل رأس المال", step2_x: "يُحوَّل رأس المال إلى الشركة بالعملات المشفرة، كما ينص العقد.",
  step3_t: "الهيكل يعمل", step3_x: "تخصص الشركة رأس المال في البرنامج المبني على أربعة مستويات استراتيجية مستقلة وغير مترابطة.",
  step4_t: "تابع كل شيء بشفافية", step4_x: "في منطقتك الشخصية ترى أداء استثمارك بشفافية: المركز والنتائج والحركات، دائماً.",

  met_eyebrow: "04 — المنهجية", met_title_pre: "كل خطوة مكتوبة في", met_title_em: "العقد",
  met_text: "يوقّع العميل عقداً مع ليبرتي كابيتال آند بارتنرز ويحوّل رأس المال إلى الشركة بالعملات المشفرة. تخصصه البنية في برنامج Safe Capital المبني على أربعة مستويات استراتيجية مستقلة. كل هذا محدد كتابياً في الوثائق التعاقدية.",
  met_f1: "العميل", met_f2: "عقد مع Liberty CP", met_f3: "تحويل بالعملات المشفرة", met_f4: "أربعة مستويات استراتيجية", met_f5: "تقرير في منطقتك",
  met_note: "تخضع الأدوار والتدفقات والمسؤوليات للوثائق التعاقدية الموقعة من العميل.",

  area_eyebrow: "05 — المنطقة الشخصية", area_title_pre: "بوابة", area_title_em: "خاصة", area_title_post: "، وليست منصة.",
  area_text: "يتوفر لكل عميل منطقة مخصصة لمتابعة مركزه بوضوح. البيانات المعروضة هنا توضيحية حصراً.",
  area_cta: "تسجيل الدخول", area_badge: "معاينة",
  area_s1: "رأس المال", area_s2: "النتيجة الصافية", area_s3: "الرصيد", area_s4: "رأس المال المسحوب",
  area_note: "قيم لأغراض التوضيح فقط. ليست بيانات حقيقية.",

  glob_eyebrow: "الحضور", glob_title: "Global Access",
  glob_text: "تخصيص رأس المال في فرص خاصة منتقاة، وإدارة احترافية لاستراتيجيات الاستثمار عبر أبرز الأسواق المالية العالمية.",

  part_eyebrow: "06 — الشركاء",
  part_text: "أولاً تتعرف على الهيكل. ثم، إن رغبت، تُبنى علاقة أوسع.",
  part_cta: "اكتشف برنامج الشركاء",

  close_title_pre: "الخطوة الأولى هي", close_title_em: "أن نتعارف",
  close_text: "كل علاقة تبدأ بمحادثة. أخبرنا بما تبحث عنه واكتشف ما إذا كانت ليبرتي كابيتال آند بارتنرز هي الهيكل المناسب لك.",
  close_cta: "تحدث مع الفريق", close_alt: "رجلا أعمال يتصافحان",

  lp_eyebrow: "ليبرتي", lp_hero_pre: "هيكل مبني حول", lp_hero_em: "رأس المال",
  lp_hero_text: "ليبرتي كابيتال آند بارتنرز هي هيكل خاص مخصص لتنظيم رأس المال وتخصيصه. ليست صندوقاً ولا بنكاً. إنها بنية متعددة المستويات، بوصول انتقائي وعلاقات تحكمها اتفاقيات فردية والوثائق التعاقدية ذات الصلة.",
  lp_prog_eyebrow: "البرنامج", lp_prog_pre: "Safe Capital", lp_prog_em: "Programme",
  lp_prog_text: "استراتيجية محايدة للسوق: الأداء مستقل عن اتجاه الأسواق. المحفظة مقوَّمة بـ USDT/USDC في جميع الأوقات، دون تعرض متبقٍّ لتقلبات أسعار العملات المشفرة.",
  lp_kpi_months: "أشهر موثقة", lp_kpi_avg: "متوسط شهري صافٍ", lp_kpi_total: "العائد الإجمالي", lp_kpi_min: "الحد الأدنى لرأس المال",
  lp_prog_note: "البيانات للفترة يوليو 2025 – مايو 2026. النتائج السابقة ليست مؤشراً على النتائج المستقبلية. أي محاكاة توضيحية.",
  lp_arch_eyebrow: "الاستراتيجية", lp_arch_pre: "أربعة مستويات،", lp_arch_em: "استراتيجية", lp_arch_post: " واحدة.",
  lp_arch_text: "كل مستوى يعمل بشكل مستقل ويولّد العائد عبر آلية غير مترابطة مع غيره. التراجع في مستوى لا يؤثر على الآخرين.",
  lp_val_eyebrow: "القيم", lp_val_pre: "ثلاث", lp_val_em: "ركائز",
  pil1_name: "الدقة", pil1_text: "لكل قرار منطق ووظيفة.",
  pil2_name: "الانضباط", pil2_text: "يُنظَّم رأس المال وفق قواعد ومعايير محددة.",
  pil3_name: "السيطرة", pil3_text: "إدارة الانكشاف والمخاطر تسبق أي اعتبار للأداء.",
  lp_close_pre: "الهيكل يُفهم", lp_close_em: "عن", lp_close_post: " قرب.",

  pp_eyebrow: "برنامج الشركاء", pp_title_pre: "علاقة تنشأ من", pp_title_em: "التجربة", pp_title_post: " المباشرة.",
  pp_text: "أولاً تصبح عميلاً. ثم، إن رغبت، يمكنك أن تصبح شريكاً. كل عميل تقدّمه يمنحك حق تقدير: مبلغ ثابت نحدده نحن.",
  pp_mem_label: "العضوية", pp_mem_a: "العضوية حالياً", pp_mem_b: "مجانية", pp_mem_c: ". وفي نهاية مرحلة الإطلاق ستصبح", pp_mem_d: "€ 150 / سنة",
  pp_f1_eyebrow: "المرحلة 1 — الاستخدام", pp_f1_pre: "متاحة", pp_f1_em: "لجميع", pp_f1_post: " العملاء.",
  pp_th1: "ترخيص العميل المقدَّم", pp_th2: "التقدير", pp_promo: "سعر الإطلاق", pp_listino: "القائمة",
  pp_f1_note: "التقدير مبلغ ثابت نحدده نحن. الترخيص بسعر € 159 هو عرض إطلاق: عند انتهائه يعود السعر إلى قائمة € 399 مع التقدير المقابل.",
  pp_f2_eyebrow: "المرحلة 2 — الشريك", pp_f2_pre: "علاقة", pp_f2_em: "أوسع",
  pp_req_pre: "الشرط: محفظة شخصية لا تقل عن",
  pp_c1: "خصم على اللوت: يُتفق عليه مع الوسيط.",
  pp_c2: "رسوم الشريك (العضوية): مجانية عند الإطلاق.",
  pp_c3: "بعد الإطلاق: € 150 / سنة.",
  pp_fixed: "التقدير مبلغ ثابت، نحدده نحن.",
  pp_note: "يخضع برنامج الشركاء للتحقق والموافقة والوثائق المعمول بها.",
  pp_close_pre: "الخطوة الأولى تبقى", pp_close_em: "دائماً", pp_close_post: " نفسها: أن نتعارف.",
  pp_cta: "تحدث مع الفريق",

  ct_eyebrow: "اتصل بنا", ct_title: "لنتحدث",
  ct_text: "إذا كنت ترغب في معرفة المزيد عن ليبرتي أو البرنامج أو برنامج الشركاء، أرسل لنا طلباً. سيتواصل معك فريقنا للتعمق.",
  ct_nome: "الاسم", ct_email: "البريد الإلكتروني", ct_tel: "الهاتف", ct_paese: "الدولة", ct_arg: "الموضوع", ct_msg: "الرسالة",
  ct_arg1: "معلومات", ct_arg2: "مشاركة", ct_arg3: "برنامج الشركاء", ct_arg4: "مساعدة",
  ct_submit: "أرسل الطلب", ct_sending: "جارٍ الإرسال…",
  ct_ok_t: "تم استلام الطلب.", ct_ok_x: "سنتواصل معك بعد أن نتولى معالجته.",

  ac_eyebrow: "وصول مخصص",
  ac_login_pre: "منطقتك", ac_login_em: "الشخصية",
  ac_reg_pre: "اطلب", ac_reg_em: "الوصول",
  ac_tab1: "تسجيل الدخول", ac_tab2: "اطلب الوصول",
  ac_email: "البريد الإلكتروني", ac_pwd: "كلمة المرور", ac_btn: "تسجيل الدخول", ac_busy: "جارٍ الدخول…",
  ac_forgot: "نسيت كلمة المرور؟",
  ac_nome: "الاسم", ac_cognome: "اسم العائلة", ac_tel: "الهاتف", ac_hint: "8 أحرف كحد أدنى.",
  ac_captcha: "تحقق: لست روبوتاً",
  ac_terms_a: "قرأت وأوافق على", ac_terms_b: "الشروط والأحكام", ac_terms_c: "وسياسة الخصوصية",
  ac_regbtn: "أرسل طلب الوصول", ac_regbusy: "جارٍ الإرسال…",
  ac_ref: "تقدّم طلبك بتقديم من عميل ليبرتي (الرمز",
  ac_ok_t: "تم استلام الطلب.",
  ac_ok_x: "أرسلنا إليك بريداً إلكترونياً: أكّد عنوانك لإكمال الطلب. بعد ذلك مباشرة سيراجعه فريقنا وستصلك رسالة تأكيد الموافقة.",
  ac_note: "كل طلب يراجعه الفريق قبل تفعيل الحساب.",
};

export default ar;
